import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import carIcon from '@iconify-icons/mdi/car';
import vehicleIcon from '@iconify-icons/mdi/car-sports-utility-vehicle'
import busIcon1 from '@iconify-icons/mdi/bus';
import busIcon from '@iconify-icons/mdi/house-circle';
import mapMarkerRadius from '@iconify-icons/mdi/map-marker-radius';
import routeIcon from '@iconify-icons/mdi/transit-detour';
import eyeIcon from '@iconify-icons/mdi/eye';
import eyeOffIcon from '@iconify-icons/mdi/eye-off';
import zoneIcon from '@iconify-icons/mdi/map';
import magnifyLockIcon from '@iconify-icons/mdi/magnify-plus';
import checkCircleOutline from '@iconify-icons/mdi/check-circle-outline';
import tripList from '@iconify-icons/mdi/format-list-bulleted-square';


import fullscreenIcon from '@iconify-icons/mdi/fullscreen';
import fullscreenExitIcon from '@iconify-icons/mdi/fullscreen-exit';

import plusIcon from '@iconify-icons/mdi/plus';
import minusIcon from '@iconify-icons/mdi/minus';

import trafficLight from '@iconify-icons/mdi/traffic-light';
import closeX from '@iconify-icons/mdi/close';
import close from '@iconify-icons/mdi/chevron-double-left';
import MapView from '@iconify-icons/mdi/world';
import alignCenter from '@iconify-icons/mdi/map-marker-circle';
import refresh from '@iconify-icons/mdi/refresh';

import Tags from './Tags';
import { useRef } from 'react';

const toggleButtons = [
  { Disabled: false, title: "Highlight Vehicle on Map", key:"Vehicle", label: 'V', icon: vehicleIcon },
  { Disabled: false, title: "Re-Aling To Center", key:"mapCenterAlign", label: 'C', icon: alignCenter },
  { Disabled: false, title: "Dispatch", key:"Dispatch", label: 'D', icon: carIcon },
  // { Disabled: false, title: "List of selected trip(s)", key:"TripLst", label: 'T', icon: tripList },
  { Disabled: false, title: "Zones", key:"Zones", label: 'Z', icon: zoneIcon },
  { Disabled: false, title: "Depot", key:"Depot", label: 'Dp', icon: busIcon },
  { Disabled: false, title: "Show Occupied", key:"Show Occupied", label: 'O', icon: eyeIcon },
  { Disabled: false, title: "Show Completed", key:"ShowCompleted", label: 'C', icon: checkCircleOutline },
  // { Disabled: false, title: "MiniMap", key:"MiniMap", label: 'M', icon: mapMarkerRadius },
  { Disabled: false, title: "Route Info Summary", key:"Routes", label: 'R', icon: routeIcon },
  { Disabled: false, title: "Zoom Lock", key:"Zoom Lock", label: 'ZM', icon: magnifyLockIcon },
  { Disabled: false, title: "Traffic", key:"Traffic", label: 'R', icon: trafficLight },
  { Disabled: false, title: "Map View", key:"MapView", label: 'M', icon: MapView },
  { Disabled: false, title: "Reset Map", key:"ResetMap", label: 'E', icon: refresh }
];

const HeaderSection = ({ onToggle, onFullScreenToggle, isFullScreen, onZoomIn, onZoomOut, onClose, className, initialToggles = {}  }) => {
  const [activeToggles, setActiveToggles] = useState({});

  // const handleToggle = (key) => {
  //   const updated = { ...activeToggles, [key]: !activeToggles[key] };
  //   setActiveToggles(updated);
  //   if (onToggle) onToggle(key, updated[key]); // Pass label and new state
  // };

  const handleToggle = (key, value = null) => {
    const newValue = value === null ? !activeToggles[key] : value;
    const updated = { ...activeToggles, [key]: newValue };
    setActiveToggles(updated);
    if (onToggle) onToggle(key, newValue);
  };


  useEffect(() => {
    if (initialToggles) {
      setActiveToggles(prev => ({ ...prev, ...initialToggles }));
    }
  }, [initialToggles]);

  const [zoomButtonVisibility, setZoomButtonVisibility] = useState('')
  const setDisabledZoomButtons = (isDisabled = false) => {
    try {
      if(isDisabled){
        setZoomButtonVisibility('none');
      }
      else{
        setZoomButtonVisibility('');
      }
    } catch (error) {
      
    }
  }

  return (
    <div className={`header-section ${className}`}  style={{
        padding: '5px',
        background: '#e7e7e7',
        borderRadius: '10px 10px 0px 0px',
        //width: "16%", 
        overflowX: "hidden"
      }}>
      <div className="action-buttons" style={{ display: 'inline-flex',alignItems:"flex-start",flexDirection:" column"}}>
        {toggleButtons.map(({ title, key, label, icon }) => {
          const isActive = activeToggles[key];
          const isVehicle = key === 'Vehicle';
          const isMapCenterAlign = key === 'mapCenterAlign';
          const isResetMap = key === 'ResetMap';
          const isKeyZoomLocked = key;
          if(isKeyZoomLocked === 'Zoom Lock' && isActive){
            title = 'Unlock Zoom';
            //setDisabledZoomButtons(true);
          }
          else if(isKeyZoomLocked === 'Unlock Zoom' && !isActive){
            title = 'Zoom Lock';
            //setDisabledZoomButtons(false);
          }

          const backgroundColor = 
          isVehicle 
            ? 'darkorange' 
            : isMapCenterAlign 
              ? '#0077cc'
              : isResetMap
                ? 'lightcoral'
                : isActive
                  ? '#3DAB58'
                  : '#444';
      
        const textColor = isVehicle || isMapCenterAlign ? 'white' : '#fff';

          return (
            <button
                key={key}
                onClick={() => handleToggle(key)}
                style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '4px 8px',
                backgroundColor: backgroundColor,
                color: textColor,
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: '12px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                borderColor: "unset",
                width: "100%"
                }}
                title={title}
            >
            <Icon 
              icon={icon} 
              width="16" 
              height="16" 
              style={{ color: isVehicle ? 'black' : '#fff' }} // light green if active
            />
            {/* {label} */}
          </button>
          );
        })}

        <div className='footer-zoom-InOutText'>
                <button onClick={onZoomIn} className='classZoombutton' title='Zoom In'>
                    <Icon icon={plusIcon} width="18" height="18" />
                </button>
                <button onClick={onZoomOut} className='classZoombutton' title='Zoom Out'>
                    <Icon icon={minusIcon} width="18" height="18" />
                </button>
             
                <button
                  title='Full Screen with Controls'
                  onClick={onFullScreenToggle}
                  style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  backgroundColor: '#444',
                  color: '#fff',
                  borderRadius: '4px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  fontWeight: 500
                  }}>
                  <Icon icon={isFullScreen ? fullscreenExitIcon : fullscreenIcon} width="18" height="18" />
                </button>

              <button
                  title='Hide Map Controls'
                  onClick={onClose}
                  style={{
                  marginTop: "5px",
                  display: 'flex',
                  alignItems: 'flex-start',
                  backgroundColor: 'darkseagreen',
                  color: 'black',
                  borderRadius: '4px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  fontWeight: 500
                  }}>   <Icon icon={close} width="18" height="18" />
              </button>
        </div>
           
      </div>
    </div>
  );
};

export default HeaderSection;




